import { SelectPeriod } from "components/hr-metrics/employee-productivity/create/SelectPeriod";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_EMPLOYEE_PRODUCTIVITY } from "services/apiEmployeeProductivity";
import { useFetch } from "services/useFetch";

const SelectPeriodContainer = () => {
    const navigate = useNavigate()
    const [selectedMonth, setSelectedMonth] = useState(null)
    const {fetching: createPeriod} = useFetch(API_EMPLOYEE_PRODUCTIVITY.CREATE_PERIOD)

    const onChangeMonth = (value) => {
        setSelectedMonth(value)
    }

    const onSubmit = () => {
        createPeriod({period: selectedMonth})
            .then(response => {
                navigate(`/human-resource-metrics/create-employee-productivity/import-data?periodId=${response?.data?.id}`)
            })
    }

    const props = {
        selectedMonth,
        onChangeMonth,
        onSubmit
    }

    return (
        <SelectPeriod {...props}/>
    )
}

export default SelectPeriodContainer
